// HeroSection.js – Vollbild-Kopfbereich der Startseite (Stil: HeroSection.css).
import React from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="ff-hero">
      <div className="ff-hero__content">
        <span className="ff-hero__eyebrow">Schleswig-Holstein · Forst &amp; Flur</span>
        <h1 className="ff-hero__title">
          Keine Kompromisse.<br />
          <em>Wenn’s um Bäume geht.</em>
        </h1>
        <p className="ff-hero__sub">
          Professionelle Baumpflege, bodenschonende Forstarbeiten und
          Flächenpflege: ökologisch durchdacht, fachgerecht ausgeführt.
        </p>
        <div className="ff-hero__actions">
          <Link
            to="/kontakt"
            className="btn-ff-primary"
            onClick={() => window.scrollTo(0, 0)}
          >
            Jetzt anfragen
          </Link>
          <a href="#leistungen" className="btn-ff-outline">
            Unsere Leistungen
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
